import { Line } from 'react-chartjs-2';
import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import classes from './LineChart.module.css'
import { CategoryScale } from 'chart.js';
import Chart from 'chart.js/auto';
import useSortAssessmentsByToc from "../hooks/useSortAssessmentsByToc"

const LineChart = ({ statisticData, currentCourse, id }) => {

    Chart.register(CategoryScale);

    const { lessonByTopic } = useSelector(state => state.topics)
    const {texts} = useSelector(state => state.translate);

    const [labels, setLabels] = useState()
    const [data, setData] = useState()

    const SortAssessments = useSortAssessmentsByToc()

    useEffect(() => {
        if (statisticData && lessonByTopic) {
            let sorted = SortAssessments(statisticData.userSummary, lessonByTopic, true)
            setLabels(sorted?.map(a => a.lessonName));
            setData(sorted?.map(a => a.score * 100));
        }
    }, [statisticData, lessonByTopic])

    const state = {
        labels: labels,
        datasets: [
            {
                label: texts.scores,
                lineTension: 0.5,
                backgroundColor: "#73ded8ad",
                borderColor: '#73DED8',
                borderWidth: 2,
                fill: true,
                data: data ? data : {}
            }
        ]
    }
    return (
        <div className={classes.LineChartContainer}>
            {<div className={classes.CourseName}>{texts.courseSummary} </div>}
            {currentCourse && <div className={classes.LineChartCourseName}>{currentCourse.discipline} </div>}
            <div className={classes.LineChart}>

                <div className={classes.LineChartWarrper}>
                    <Line data={state} options={{
                        title: { display: true, text: texts.scores, fontSize: 20, },
                        plugins: {
                            legend: {
                                display: false,
                            },

                        },
                        scales: {
                            // x: {
                            //     ticks: {
                            //         callback: function (label) {
                            //             return `${this.getLabelForValue(label)}`
                            //         }
                            //     }
                            // },
                            // secondXAxis: {
                            //     axis: 'x',
                            //     labels: ['V2', 'syntax', 'in', 'v3','kk'],
                            //     grid: {
                            //         drawOnChartArea: false
                            //     }
                            // },

                            y: {
                                beginAtZero: true,
                                grid: {
                                    drawBorder: false, // <-- this removes y-axis line
                                    lineWidth: 0.0001,
                                },
                                ticks: {
                                    color: '#757575',
                                    align: 'center',
                                    padding: 15,
                                    font: {
                                        size: 12,
                                    }
                                },


                            },
                            x: {
                                grid: {
                                    drawBorder: false, // <-- this removes y-axis line
                                    lineWidth: 0.0001,


                                },

                                gridLines: {
                                    offsetGridLines: true
                                },

                                ticks: {

                                    color: '#141938',
                                    align: 'center',
                                    padding: 15,
                                    font: {
                                        size: 14,
                                    }
                                },
                                layout: {
                                    padding: {
                                        left: 1
                                    }
                                },
                            },

                        }
                    }}
                    />
                </div>

            </div>
        </div>
    )
}
export default LineChart